import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import FirstUpper from '../FirstUpper';

interface Props {
	onClick: () => void;
	text: string;
	firstUpper?: boolean;
	className?: string;
	dataId?: string;
}

const Button: React.FC<Props> = ({
	onClick,
	text,
	firstUpper = false,
	className,
	dataId,
}) => {
	const { t } = useTranslation();

	let title: any = t(text);

	if (firstUpper) {
		title = <FirstUpper>{title}</FirstUpper>;
	}

	return (
		<a
			className={['btn btn-submit', className].join(' ')}
			onClick={onClick}
			data-id={dataId}
		>
			{title}
		</a>
	);
};

export default Button;
